import React, { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { SelectOtherCoaches, SelectPrimaryTherapist } from '../../SetCareTeamForm/SelectCareTeam'
import { CoachProfileWithCoachID } from '../../SetCareTeamForm/useLoadCoachProfiles'
import { CareTeam } from '../../SetCareTeamForm/useLoadSetCareTeamData'

type Props = {
  /** The follow-up program the careteam is being assembled for; the pickers stay hidden until one is chosen. */
  followUpProgramID?: string
  oldCareTeam?: CareTeam
  coachProfiles: Array<CoachProfileWithCoachID>
}

const SelectCareTeamToKeep: React.FC<Props> = ({ followUpProgramID, oldCareTeam, coachProfiles }) => {
  const { values, setFieldValue } = useFormikContext<Partial<CareTeam>>()
  const currentPrimaryCoachID = oldCareTeam?.primaryCoachID

  // Default to carrying the whole current careteam over. Seeded from an effect because the careteam query
  // resolves after the form mounts, and both fields are seeded together so the mutation never receives a
  // primary coach without a careteam selection to apply it with.
  useEffect(() => {
    if (values.primaryCoachID === undefined && currentPrimaryCoachID) {
      setFieldValue('primaryCoachID', currentPrimaryCoachID)
      setFieldValue('careteamCoachIDs', oldCareTeam?.careteamCoachIDs ?? [])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPrimaryCoachID])

  if (!followUpProgramID || !currentPrimaryCoachID) {
    return null
  }

  return (
    <>
      <SelectPrimaryTherapist coachProfiles={coachProfiles} />
      <SelectOtherCoaches
        careTeam={{ primaryCoachID: values.primaryCoachID, careteamCoachIDs: values.careteamCoachIDs ?? [] }}
        coachProfiles={coachProfiles}
      />
    </>
  )
}

export default SelectCareTeamToKeep
